import React from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, TextField, Paper, withStyles, Button, FormHelperText } from '@material-ui/core';
import PageTitle from '../../components/PageTitle/PageTitle';
import FormInputLabel from '../../components/FormInputLabelView';
import Swal from 'sweetalert2';
import Loader from '../../components/Loader/LoaderView';
import { withTranslation } from 'react-i18next';
import { clearLocalStorage } from '../../utils/common';
const errMessage = {
  required: 'required_field',
  needsLength: 'this_field_needs_length',
};

class LocationsPage extends React.Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this); // i think you are missing this
    // this.initData = this.initData;
    this.state = {
      data: {
        id: null,
        name: '',
        homeNumber: '',
        road: '',
        subDistrict: '',
        district: '',
        province: '',
        postcode: '',
        description: '',
      },
      errorField: {
        name: { flag: false, msg: '' },
        district: { flag: false, msg: '' },
        province: { flag: false, msg: '' },
        postcode: { flag: false, msg: '' },
      },
    };
  }

  async componentDidMount() {
    const { offset, limit, search, sort, order } = this.props.locations.toJS();
    await this.props.locations.getLocationList(offset, limit, search, sort, order);
    this.initData();
  }
  goBack() {
    this.props.locations.setAction('action', true);
    this.props.history.goBack();
  }

  initData() {
    const { locations } = this.props.locations.toJS();
    const serialPath = this.props.location.pathname.replace('/app/locations/', '');
    const id = Number(serialPath.replace('/edit', ''));
    const showLocationsData = locations.data.find((item) => item.id === id);
    if (showLocationsData) {
      this.setState({
        data: {
          id: showLocationsData.id,
          name: showLocationsData.name,
          homeNumber: showLocationsData.homeNumber,
          road: showLocationsData.road,
          subDistrict: showLocationsData.subDistrict,
          district: showLocationsData.district,
          province: showLocationsData.province,
          postcode: showLocationsData.postcode,
          description: showLocationsData.description,
        },
      });
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.clearErrorField(name);
    this.setState((prevState) => {
      prevState.data[name] = value;
      return prevState;
    });
  };

  validate() {
    const { t } = this.props;
    const { data } = this.state;
    let checkName = !data.name ? true : false;
    let checkDistrict = !data.district ? true : false;
    let checkProvince = !data.province ? true : false;
    let checkPostcode = false;
    let msgPostcode = '';
    if (!data.postcode) {
      checkPostcode = true;
      msgPostcode = t(errMessage.required);
    } else if (data.postcode.length < 5) {
      checkPostcode = true;
      msgPostcode = t(errMessage.needsLength).replace('x', 5);
    }

    this.setState({
      errorField: {
        name: {
          flag: checkName,
          msg: t(errMessage.required),
        },
        district: {
          flag: checkDistrict,
          msg: t(errMessage.required),
        },
        province: {
          flag: checkProvince,
          msg: t(errMessage.required),
        },
        postcode: {
          flag: checkPostcode,
          msg: msgPostcode,
        },
      },
    });
    return !(checkName || checkDistrict || checkProvince || checkPostcode);
  }

  clearErrorField(key) {
    if (key === 'name') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          name: { flag: false, msg: '' },
        },
      });
    }
    if (key === 'district') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          district: { flag: false, msg: '' },
        },
      });
    }
    if (key === 'province') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          province: { flag: false, msg: '' },
        },
      });
    }
    if (key === 'postcode') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          postcode: { flag: false, msg: '' },
        },
      });
    }
  }

  handleCreateLocation = async (data) => {
    const { t } = this.props;
    if (this.validate()) {
      try {
        const result = await this.props.locations.createLocation(data);
        if (result.statusCode === 200) {
          Swal.fire({ html: `<h4>${t('create_success')}`, type: 'success' }).then(async (resultSuccess) => {
            if (resultSuccess.value) {
              this.props.history.push('../locations');
            }
          });
        } else {
          Swal.fire({ html: `<h4>${t('failed_to_create')}`, type: 'error' });
        }
      } catch (e) {
        if (e.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        } else if (e.statusCode === 400) {
          const msg = e.error.message || `${t('failed_to_create')}`;
          Swal.fire({ html: `<h4>${msg}`, type: 'error' });
        } else {
          Swal.fire({ html: `<h4>${t('failed_to_create')}`, type: 'error' });
        }
      }
    }
  };

  handleEditLocation(data) {
    const { t } = this.props;
    if (this.validate()) {
      Swal.fire({
        html: `<h4>${t('edit_location')}`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: `${t('edit')}`,
        cancelButtonText: `${t('cancel')}`,
        reverseButtons: true,
        customClass: {
          container: 'my-swal',
        },
      }).then(async (result) => {
        if (result.value) {
          try {
            const result = await this.props.locations.updateLocation(data);
            if (result.statusCode === 200) {
              Swal.fire({ html: `<h4>${t('update_success')}`, type: 'success' }).then(async (resultSuccess) => {
                if (resultSuccess.value) {
                  this.props.locations.setAction('action', true);
                  this.props.history.push('../../locations');
                } else {
                  Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
                }
              });
            }
          } catch (e) {
            if (e.statusCode === 401) {
              clearLocalStorage();
              window.location.href = '/login';
            } else if (e.statusCode === 400) {
              const msg = e.error.message || `${t('failed_to_update')}`;
              Swal.fire({ html: `<h4>${msg}`, type: 'error' });
            } else {
              Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
            }
          }
        }
      });
      // this.props.locations.updateLocation(data)
    }
  }

  renderFormCreate() {
    const { classes, t } = this.props;
    const { data } = this.state;
    return (
      <React.Fragment>
        <Paper className={classes.paper}>
          <PageTitle title={t('create_a_location')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={data.name}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                inputProps={{ maxLength: 256 }}
                error={!data.reset ? this.state.errorField.name.flag : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.name.flag : true}
                id='component-error-text'
              >
                {this.state.errorField.name.msg}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('home_number')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='homeNumber'
                name='homeNumber'
                fullWidth
                value={data.homeNumber}
                onChange={this.handleChange}
                inputProps={{ maxLength: 256 }}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('road')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='road'
                name='road'
                fullWidth
                value={data.road}
                onChange={this.handleChange}
                inputProps={{ maxLength: 64 }}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('sub_district')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='subDistrict'
                name='subDistrict'
                fullWidth
                value={data.subDistrict}
                onChange={this.handleChange}
                inputProps={{ maxLength: 64 }}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('district')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='district'
                name='district'
                fullWidth
                value={data.district}
                onChange={this.handleChange}
                inputProps={{ maxLength: 64 }}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.district.flag : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.district.flag : true}
                id='component-error-text'
              >
                {this.state.errorField.district.msg}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('province')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='province'
                name='province'
                fullWidth
                value={data.province}
                onChange={this.handleChange}
                inputProps={{ maxLength: 64 }}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.province.flag : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.province.flag : true}
                id='component-error-text'
              >
                {this.state.errorField.province.msg}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('postcode')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='postcode'
                name='postcode'
                fullWidth
                value={data.postcode}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                inputProps={{ maxLength: 5 }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
                error={!data.reset ? this.state.errorField.postcode.flag : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.postcode.flag : true}
                id='component-error-text'
              >
                {this.state.errorField.postcode.msg}
              </FormHelperText>
            </Grid>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('description')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='description'
                name='description'
                fullWidth
                value={data.description}
                onChange={this.handleChange}
                inputProps={{ maxLength: 256 }}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => this.handleCreateLocation(data)}
                  className={classes.button}
                >
                  {t('create')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  renderFormEdit() {
    const { classes, t } = this.props;
    const { data } = this.state;
    const locations = this.props.locations.toJS();
    return (
      <React.Fragment>
        <Loader loading={locations.loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('edit_a_location')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={data.name}
                onChange={this.handleChange}
                inputProps={{ maxLength: 256 }}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.name.flag : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.name.flag : true}
                id='component-error-text'
              >
                {this.state.errorField.name.msg}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('home_number')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='homeNumber'
                name='homeNumber'
                fullWidth
                value={data.homeNumber}
                onChange={this.handleChange}
                inputProps={{ maxLength: 256 }}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('road')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='road'
                name='road'
                fullWidth
                value={data.road}
                onChange={this.handleChange}
                inputProps={{ maxLength: 64 }}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('sub_district')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='subDistrict'
                name='subDistrict'
                fullWidth
                value={data.subDistrict}
                onChange={this.handleChange}
                inputProps={{ maxLength: 64 }}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('district')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='district'
                name='district'
                fullWidth
                value={data.district}
                onChange={this.handleChange}
                inputProps={{ maxLength: 64 }}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.district.flag : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.district.flag : true}
                id='component-error-text'
              >
                {this.state.errorField.district.msg}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('province')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='province'
                name='province'
                fullWidth
                value={data.province}
                onChange={this.handleChange}
                inputProps={{ maxLength: 64 }}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.province.flag : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.province.flag : true}
                id='component-error-text'
              >
                {this.state.errorField.province.msg}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('postcode')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='postcode'
                name='postcode'
                fullWidth
                value={data.postcode}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                inputProps={{ maxLength: 5 }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
                error={!data.reset ? this.state.errorField.postcode.flag : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.postcode.flag : true}
                id='component-error-text'
              >
                {this.state.errorField.postcode.msg}
              </FormHelperText>
            </Grid>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('description')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='description'
                name='description'
                fullWidth
                value={data.description}
                onChange={this.handleChange}
                inputProps={{ maxLength: 256 }}
                variant='outlined'
                margin='dense'
              />
            </Grid>
            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => this.handleEditLocation(data)}
                  className={classes.button}
                >
                  {t('edit')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  renderView() {
    const { classes, t } = this.props;
    const { locations, loading } = this.props.locations.toJS();
    const serialPath = this.props.location.pathname.replace('/app/locations/', '');
    const id = Number(serialPath.replace('/view', ''));
    const viewDetail = locations.data.find((item) => item.id === id);
    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('view_a_location')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={viewDetail.name}
                // onChange={this.handleChange}
                disabled
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('home_number')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='homeNumber'
                name='homeNumber'
                fullWidth
                value={viewDetail.homeNumber}
                disabled
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('road')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='road'
                name='road'
                fullWidth
                value={viewDetail.road}
                disabled
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('sub_district')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='subDistrict'
                name='subDistrict'
                fullWidth
                value={viewDetail.subDistrict}
                disabled
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('district')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='district'
                name='district'
                fullWidth
                value={viewDetail.district}
                disabled
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('province')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='province'
                name='province'
                fullWidth
                value={viewDetail.province}
                disabled
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('postcode')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='postcode'
                name='postcode'
                fullWidth
                value={viewDetail.postcode}
                disabled
                variant='outlined'
                margin='dense'
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('description')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='description'
                name='description'
                fullWidth
                value={viewDetail.description}
                disabled
                variant='outlined'
                margin='dense'
              />
            </Grid>
            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  render() {
    const path = this.props.match.path.replace('/app/locations/:id/', '');
    let result;
    switch (path) {
      case 'edit':
        result = this.renderFormEdit();
        break;
      case 'view':
        result = this.renderView();
        break;
      default:
        result = this.renderFormCreate();
        break;
    }
    return result;
    // return (
    //   <React.Fragment>
    //     {path === 'edit' ? this.renderFormEdit(): this.renderFormCreate()}
    //   </React.Fragment>
    // );
  }
}

const styles = (theme) => ({
  paper: {
    padding: '24px',
    margin: '30px',
  },
  wrapContain: {
    padding: 20,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 1,
  },
  formControl: {
    width: '100%',
  },
});
export const page = inject('locations')(observer(LocationsPage));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
